import { z } from "zod";

import { CustomColumnFrequency } from "@/enum/list.enum";

import { ColumnConfigSchema } from "./columnConfig";

export const ColumnValueSchema = z.object({
	id: z.number(),
	columnConfigId: z.number(),
	columnConfig: ColumnConfigSchema,
	listPersonId: z.number(),
	value: z.any(),
	sourceUrl: z.string().nullable(),
	createdAt: z.string(),
	answerExplanation: z.string().nullable(),
});

export const ColumnConfigFullInfoSchema = ColumnConfigSchema.extend({
	id: z.number(),
	listId: z.number().nullable(),
	trackerId: z.number().nullable(),
	companyId: z.number().nullable(),
	initialListId: z.number().nullable(),
	frequency: z.nativeEnum(CustomColumnFrequency).nullable(),
	updateOrOnce: z.boolean().nullable(),
	sourceConfig: z.any().nullable(),
	score: z.number().nullable(),
	locale: z.string().nullable(),
	sumUpScoreOverTime: z.boolean(),
	saveAsTemplate: z.boolean(),
	online: z.boolean(),
	single: z.boolean(),
	templateId: z.number().nullable(),
	deletedById: z.number().nullable(),
	createdById: z.number().nullable(),
	createdAt: z.string(),
	updatedAt: z.string(),
	deletedAt: z.string().nullable(),
});

export const ColumnValueInfoSchema = ColumnValueSchema.extend({
	listPersonId: z.number().nullable(),
	trackerOrganizationId: z.number().nullish(),
	trackerPersonId: z.number().nullish(),
	trackerId: z.number().nullish(),
	updatedAt: z.string(),
	columnConfig: ColumnConfigFullInfoSchema,
});

export const RunPromptRequestSchema = z.object({
	message: z.string(),
	listPersonId: z.number(),
});

export const RunPromptResponseSchema = z.object({
	message: z.string(),
	columnValues: z.array(ColumnValueInfoSchema),
});

export const RunPromptColumnValueUpdateSchema = z.object({
	companyId: z.number(),
	listId: z.number(),
	listPersonId: z.number(),
	columnValue: ColumnValueInfoSchema,
});

export type ColumnValue = z.infer<typeof ColumnValueSchema>;

export type ColumnConfigFullInfo = z.infer<typeof ColumnConfigFullInfoSchema>;

export type ColumnValueInfo = z.infer<typeof ColumnValueInfoSchema>;

export type RunPromptRequest = z.infer<typeof RunPromptRequestSchema>;

export type RunPromptResponse = z.infer<typeof RunPromptResponseSchema>;

export type RunPromptColumnValueUpdate = z.infer<typeof RunPromptColumnValueUpdateSchema>;
